import assign from 'lodash/assign';

import ChatGatewayBase from './ChatGatewayBase';
import configureSmooch from 'configuration/configureProvider';

const DAY = 24 * 60 * 60 * 1000;
const SESSION_KEY = 'gladlySession';

export default class SmoochChatGateway extends ChatGatewayBase {
  constructor(smooch, xhr, sessionStorage) {
    super();
    this.smooch = smooch;
    this.xhr = xhr;
    this.sessionStorage = sessionStorage;
  }

  configureProvider(providerId) {
    configureSmooch(providerId).then(() => {
      this.notifyObservers('handleProviderConfigured', {});
    });
  }

  auth(identity) {
    this.identity = identity;
    const payload = {
      email: this.identity.email,
      name: this.identity.name,
      loginDomain: this.loginDomain,
      appId: this.appId,
    };

    let authCredentials = this.sessionStorage.getSession();
    if (authCredentials && authCredentials.jwt) {
      this.login(authCredentials);
    } else {
      this.xhr.post(
        `${this.orgDomain}/api/smooch/v1/authenticate`,
        {
          json: true,
          body: payload,
        },
        (err, resp) => {
          if (err) {
            this.handleServerError('CONNECTION_ERROR', err); // could not connect to supernova
            return;
          }

          const body = resp && resp.body;
          if (resp.statusCode !== 200) {
            this.handleServerError(resp.statusCode, body && body.message);
          } else if (body && body.jwt) {
            if (!body.gladlyCustomerId) {
              body.gladlyCustomerId = this.identity.gladlyCustomerId;
            }
            this.saveAuthCredentials(body);
            this.login(body);
          } else {
            this.notifyObservers('handleError', 'no jwt returned');
          }
        }
      );
    }
  }

  saveAuthCredentials(authCredentials) {
    const { userId, jwt, gladlyCustomerId } = authCredentials;
    this.sessionStorage.patchSession({ userId, gladlyCustomerId, jwt, created: Date.now() });
  }

  login(respBody) {
    const { userId, jwt, gladlyCustomerId } = respBody;
    if (!gladlyCustomerId) {
      this.handleMissingGladlyCustomerId();
      return;
    }

    this.smooch
      .login(userId, jwt)
      .then(
        this.handleAuthenticatedSuccess.bind(this, { userId, gladlyCustomerId, jwt }),
        this.handleAuthenticatedError.bind(this)
      );
  }

  handleServerError(reason, err) {
    this.notifyObservers('handleServerError', { reason, err });
  }

  handleAuthenticatedSuccess({ userId, gladlyCustomerId, jwt }) {
    this.identity = assign(this.identity, { id: userId, gladlyCustomerId });
    this.notifyObservers('handleAuthenticatedSuccess', this.identity);
  }

  handleAuthenticatedError() {
    this.sessionStorage.removeSession();
    this.notifyObservers('handleAuthenticatedError', 'AUTHENTICATION_ERROR');
  }

  handleMissingGladlyCustomerId() {
    this.sessionStorage.removeSession();
    this.notifyObservers('handleAuthNewUser', {});
  }
}
